import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/goal-arrow.png'
import _imports_1 from '@/assets/images/icons/child-goal.png'
import _imports_2 from '../../../../assets/images/background/auth.png'


const _withScopeId = n => (_pushScopeId("data-v-304583b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__goal-management-student-detail p-10 md-down:px-4" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_4 = { class: "__breadcrumbs__decorate" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md-down:hidden" }, "Xem kết quả mục tiêu", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:hidden" }, "KQ mục tiêu", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2 text-neutral-400"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_8 = { class: "__goal-management-student-detail__header pt-5" }
const _hoisted_9 = { class: "flex justify-between items-center w-full" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_13 = { class: "ml-4" }
const _hoisted_14 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_15 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_16 = { class: "bg-white shadow-sm rounded-2xl mt-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between p-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Kết quả mục tiêu ")
], -1))
const _hoisted_18 = { class: "p-6 border-t border-orange-100" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-1/5 text-neutral-500",
  style: {"min-width":"150px","width":"150px"}
}, " Nội dung ", -1))
const _hoisted_21 = { class: "text-neutral-600" }
const _hoisted_22 = {
  key: 0,
  class: "goal-block text-sm font-medium text-neutral-700 mt-2"
}
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3 h-3",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "text-neutral-400 text-xs font-semibold mt-2 flex items-center gap-2 ml-5" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "4",
  height: "4",
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.064 3.3C1.644 3.3 1.284 3.156 0.984 2.856C0.684 2.556 0.54 2.196 0.54 1.776C0.54 1.368 0.684 1.02 0.984 0.732C1.284 0.444 1.644 0.3 2.064 0.3C2.472 0.3 2.82 0.444 3.108 0.732C3.396 1.02 3.54 1.368 3.54 1.776C3.54 2.196 3.396 2.556 3.108 2.856C2.82 3.156 2.472 3.3 2.064 3.3Z",
    fill: "#94A3B8"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "KẾT QUẢ", -1))
const _hoisted_28 = { class: "progress-bar overflow-hidden" }
const _hoisted_29 = { class: "text-neutral-400 text-xs font-semibold" }
const _hoisted_30 = { class: "flex items-center gap-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3 h-3",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "ml-5 flex items-center gap-2 mt-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-400 text-xs font-semibold" }, " KẾT QUẢ ", -1))
const _hoisted_34 = { class: "progress-bar overflow-hidden" }
const _hoisted_35 = { class: "ml-5 flex items-center gap-2 mt-2" }
const _hoisted_36 = {
  key: 0,
  class: "plan_name"
}
const _hoisted_37 = {
  key: 1,
  width: "4",
  height: "4",
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M2.064 3.3C1.644 3.3 1.284 3.156 0.984 2.856C0.684 2.556 0.54 2.196 0.54 1.776C0.54 1.368 0.684 1.02 0.984 0.732C1.284 0.444 1.644 0.3 2.064 0.3C2.472 0.3 2.82 0.444 3.108 0.732C3.396 1.02 3.54 1.368 3.54 1.776C3.54 2.196 3.396 2.556 3.108 2.856C2.82 3.156 2.472 3.3 2.064 3.3Z",
  fill: "#94A3B8"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "flex items-center mt-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-1/5 text-neutral-500",
  style: {"min-width":"150px","width":"150px"}
}, " Lĩnh vực ", -1))
const _hoisted_43 = { class: "text-neutral-600" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center mt-6"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-1/5 text-neutral-500",
  style: {"min-width":"150px","width":"150px"}
}, " Nhận xét ", -1))
const _hoisted_46 = { class: "text-neutral-600" }
const _hoisted_47 = {
  key: 1,
  class: "flex items-center mt-6"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-1/5 text-neutral-500",
  style: {"min-width":"150px","width":"150px"}
}, " Kết quả ", -1))
const _hoisted_49 = { class: "text-neutral-600" }
const _hoisted_50 = { class: "flex items-center mt-6" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-1/5 text-neutral-500",
  style: {"min-width":"150px","width":"150px"}
}, " Ghi chú ", -1))
const _hoisted_52 = { class: "text-neutral-600" }
const _hoisted_53 = {
  key: 0,
  class: "bg-white mt-8 p-6 shadow-sm rounded-2xl"
}
const _hoisted_54 = { class: "flex" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"16px","height":"16px","min-height":"16px","min-width":"16px"},
  class: "bg-green-500 rounded-full mr-4"
}, null, -1))
const _hoisted_56 = { class: "font-semibold text-neutral-500 -mt-1" }
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<div class=\"relative my-12\" data-v-304583b7><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\" data-v-304583b7><div class=\"w-full border-t border-neutral-300\" data-v-304583b7></div></div><div class=\"relative flex justify-center\" data-v-304583b7><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl\" data-v-304583b7> Media của mục tiêu </div></div></div>", 1)
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["src"]
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 2,
  class: "relative"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"aspect-ratio":"1","height":"100%"},
  class: "rounded-lg object-cover shadow-lg"
}, null, -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black opacity-20" }, null, -1))
const _hoisted_67 = {
  key: 3,
  style: {"left":"50%","top":"50%","transform":"translate(-50%, -50%)"},
  class: "absolute flex flex-col items-center"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "55",
  height: "55",
  viewBox: "0 0 55 55",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { opacity: "0.5" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "54.5",
      height: "54.5",
      rx: "27.25",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34.4948 28.5672L24.9024 36.9606C23.7709 37.9507 22 37.1471 22 35.6436V18.8568C22 17.3532 23.7709 16.5497 24.9024 17.5397L34.4948 25.9332C35.2917 26.6304 35.2917 27.8699 34.4948 28.5672Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 4,
  class: "absolute bottom-2 left-4 z-10 font-medium text-white"
}
const _hoisted_71 = { key: 2 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500" }, " Mục tiêu này hiện chưa có hình ảnh / video nào được tải lên. ", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<div class=\"relative my-12\" data-v-304583b7><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\" data-v-304583b7><div class=\"w-full border-t border-neutral-300\" data-v-304583b7></div></div><div class=\"relative flex justify-center\" data-v-304583b7><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl\" data-v-304583b7> Phản hồi </div></div></div>", 1)
const _hoisted_75 = { class: "mt-14" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  class: "overflow-x-auto scroll-bar--none",
  id: "feedback-box"
}
const _hoisted_78 = { class: "flex flex-nowrap gap-8" }
const _hoisted_79 = {
  style: {"width":"400px"},
  class: "flex bg-white rounded-xl border-sm p-4 w-fit h-fit gap-6 shadow relative"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.0146 0C5.39191 0 0 5.38537 0 12C0 15.4829 1.5238 18.7902 4.13185 21.0732C5.04027 21.8634 6.0659 22.5073 7.15015 23.0049C8.70325 23.6488 10.3443 24 12.0146 24C13.6849 24 15.3259 23.6488 16.8497 22.9756C17.9633 22.478 18.9596 21.8341 19.868 21.0439C22.5054 18.761 23.9999 15.4537 23.9999 11.9707C24.0292 5.38537 18.6373 0 12.0146 0ZM12.0146 4.47805C14.8864 4.47805 17.2014 6.81951 17.2014 9.65854C17.2014 12.4976 14.8571 14.839 12.0146 14.839C9.17212 14.839 6.82781 12.4976 6.82781 9.65854C6.82781 6.81951 9.14281 4.47805 12.0146 4.47805ZM19.0475 20.9854C18.9596 21.0732 18.8717 21.1317 18.7545 21.2195C18.608 21.3073 18.4908 21.3951 18.3442 21.5122C18.2563 21.5707 18.1684 21.6293 18.0512 21.6878C17.9047 21.7756 17.7288 21.8634 17.5823 21.9512C17.4944 22.0098 17.4065 22.039 17.3479 22.0976C17.1135 22.2146 16.8497 22.361 16.586 22.4488C15.1501 23.0927 13.597 23.4146 12.0146 23.4146C10.4322 23.4146 8.87908 23.0927 7.41388 22.4488C6.41755 22.0098 5.50913 21.4244 4.65932 20.7512C5.36261 18.322 7.64831 16.6244 10.2564 16.6244H13.7728C16.3809 16.6244 18.6373 18.322 19.3406 20.7512C19.2527 20.8098 19.1647 20.8976 19.0475 20.9854Z",
      fill: "#F4C870"
    })
  ])
], -1))
const _hoisted_81 = { class: "text-sm text-neutral-400 absolute right-4 top-4" }
const _hoisted_82 = { class: "font-semibold text-yellow-600 mb-1" }
const _hoisted_83 = {
  key: 0,
  class: "flex items-center justify-center mt-10"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 12L6 8L10 4",
    stroke: "#48566A",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 12L10 8L6 4",
    stroke: "#48566A",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500" }, " Mục tiêu chưa có phản hồi nào từ Phụ huynh. ", -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = /*#__PURE__*/_createStaticVNode("<div class=\"relative my-12\" data-v-304583b7><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\" data-v-304583b7><div class=\"w-full border-t border-neutral-300\" data-v-304583b7></div></div><div class=\"relative flex justify-center\" data-v-304583b7><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl\" data-v-304583b7> Lịch sử của mục tiêu </div></div></div>", 1)
const _hoisted_92 = {
  key: 3,
  class: "shadow-sm sm:rounded-2xl overflow-hidden mt-8"
}
const _hoisted_93 = { class: "overflow-x-auto scroll-bar" }
const _hoisted_94 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_95 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase whitespace-nowrap tracking-wider"
    }, " Kết quả "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Cảm xúc "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"width":"350px"}
    }, " Hoạt động "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"width":"100px"}
    }, " ALBUM "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"width":"350px"}
    }, " Ghi chú ")
  ])
], -1))
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "px-4 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_99 = {
  class: "px-6 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"150px"}
}
const _hoisted_100 = {
  class: "px-6 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"150px"}
}
const _hoisted_101 = {
  class: "px-6 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"100px"}
}
const _hoisted_102 = { class: "whitespace-normal" }
const _hoisted_103 = ["src"]
const _hoisted_104 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { class: "whitespace-nowrap text-neutral-700" }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z",
    fill: "#E5A42B"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z",
    fill: "#E5A42B"
  })
], -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = {
  class: "px-6 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"300px","min-width":"300px"}
}
const _hoisted_111 = { class: "whitespace-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewPhoto = _resolveComponent("ViewPhoto")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.imageShow && _ctx.photos.length)
      ? (_openBlock(), _createBlock(_component_ViewPhoto, {
          key: _ctx.photosIndex,
          images: _ctx.photos,
          index: _ctx.photosIndex,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageShow = false))
        }, null, 8, ["images", "index"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "md-down:hidden",
            to: `/report/monthly-report/${_ctx.studentId}?month_start=${_ctx.monthly_start}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Báo cáo " + _toDisplayString(_ctx.$filters.terminology('plan')), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            class: "md:hidden",
            to: `/report/monthly-report/${_ctx.studentId}?month_start=${_ctx.monthly_start}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Kế hoạch ")
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_DaIcon, {
              name: "das--chevron-down",
              class: "transform -rotate-90 h-3 w-3 mx-2"
            })
          ]),
          _hoisted_5,
          _hoisted_6
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
        }, [
          _hoisted_7,
          _createTextVNode(" Thoát ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: `/record/student/${_ctx.report?.student?.id}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.report?.student?.profile_photo?.w200)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      style: {"min-width":"56px"},
                      class: "shadow-sm inline-block h-14 w-14 rounded-full",
                      src: _ctx.report?.student?.profile_photo?.w200,
                      alt: ""
                    }, null, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      style: _normalizeStyle([{"min-width":"56px"}, {
								background:
									_ctx.report?.student?.profile_photo?.default
										?.color,
							}]),
                      class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                    }, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.report?.student?.profile_photo?.default
										?.initial), 1)
                    ], 4)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.report?.student?.name), 1),
                  (_ctx.report?.student?.age)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.report?.student?.age) + " " + _toDisplayString(_ctx.report?.student?.learning_time
										? `| ${_ctx.report?.student?.learning_time}`
										: ''), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.reportDetail?.assessment_report?.goal.name), 1),
              (_ctx.goals?.parent?.sub_goal_count > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", null, _toDisplayString(_ctx.goals?.parent.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.goals?.parent?.sub_goal_count) + " MỤC TIÊU ", 1),
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({
											background: _ctx.$filters.tagResult(
												_ctx.goals?.complete_percent
											)?.background,
											width: _ctx.goal?.complete_percent + '%',
										}),
                          class: "h-full"
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.goals.complete_percent || 0) + "% ", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals?.parent.sub_goals, (g) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "ml-5 mt-2",
                        key: g.id
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", {
                            class: _normalizeClass({
											'font-semibold': g.id === _ctx.goals?.id,
										})
                          }, _toDisplayString(g.name), 3)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", {
                              style: _normalizeStyle({
												background: _ctx.$filters.tagResult(
													g.complete_percent
												)?.background,
												width: g.complete_percent + '%',
											}),
                              class: "h-full"
                            }, null, 4)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          (g?.plan_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(g?.plan_name), 1))
                            : _createCommentVNode("", true),
                          (g?.plan_name)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            innerHTML: _ctx.getStatus(g?.state)
                          }, null, 8, _hoisted_40)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.goal?.skill?.name), 1)
          ]),
          (_ctx.reportDetail?.assessment_report?.note)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.reportDetail?.assessment_report?.note), 1)
              ]))
            : _createCommentVNode("", true),
          (
						_ctx.reportDetail?.assessment_report?.result ||
						_ctx.reportDetail?.assessment_result
					)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.reportDetail?.assessment_report?.result ||
							_ctx.reportDetail?.assessment_result), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.reason()), 1)
          ])
        ])
      ]),
      (
				_ctx.reportDetail?.assessments &&
				_ctx.reportDetail?.assessments.length > 0
			)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.reportDetail?.assessment_report?.goal.name), 1)
            ]),
            _createVNode(_component_apexchart, {
              type: "line",
              height: "500",
              options: _ctx.chartOptions_,
              series: _ctx.series_,
              ref: "lineChart"
            }, null, 8, ["options", "series"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_57,
      (_ctx.goal?.goal_media && _ctx.goal?.goal_media.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countMedia(_ctx.goal), (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"aspect-ratio":"1"},
                  class: "rounded-lg bg-neutral-200 relative",
                  key: i,
                  onClick: ($event: any) => (_ctx.openMediaPopup(_ctx.goal?.goal_media, i - 1))
                }, [
                  (_ctx.goal?.goal_media[i - 1]?.asset_type === 'image')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        style: {"aspect-ratio":"1","height":"100%"},
                        class: "rounded-lg object-cover shadow-lg",
                        src: _ctx.loadImage(_ctx.goal?.goal_media[i - 1]),
                        alt: ""
                      }, null, 8, _hoisted_61))
                    : (_ctx.loadThumbnail(_ctx.goal?.goal_media[i - 1]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          style: {"aspect-ratio":"1","height":"100%"},
                          class: "rounded-lg object-cover shadow-lg",
                          src: _ctx.loadThumbnail(_ctx.goal?.goal_media[i - 1]),
                          alt: ""
                        }, null, 8, _hoisted_62))
                      : (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65)),
                  _hoisted_66,
                  (_ctx.goal?.goal_media[i - 1]?.asset_type === 'video')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69))
                    : _createCommentVNode("", true),
                  (_ctx.goal?.goal_media[i - 1]?.inserted_at)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.$filters.formatDate(
								_ctx.goal?.goal_media[i - 1]?.inserted_at
							)), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_60))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73)),
      _hoisted_74,
      _createElementVNode("div", _hoisted_75, [
        (_ctx.goal && _ctx.goal.chat_messages?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goal.chat_messages, (g) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: g.id
                    }, [
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.timeSinceHour(g.inserted_at)), 1),
                          _createElementVNode("div", _hoisted_82, _toDisplayString(g?.chat_group_user
												?.elationship_role ||
											'Phụ huynh') + " bé " + _toDisplayString(_ctx.student?.name || ''), 1),
                          _createElementVNode("div", null, _toDisplayString(g.text), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.scrollable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollLeft())),
                      class: "h-11 w-11 bg-white shadow-sm rounded-tl-lg rounded-bl-lg flex items-center justify-center border-2 border-neutral-200 cursor-pointer hover:bg-yellow-50"
                    }, _hoisted_85),
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollRight())),
                      class: "h-11 w-11 bg-white shadow-sm rounded-tr-lg rounded-br-lg border-l-0 flex items-center justify-center border-2 border-neutral-200 cursor-pointer hover:bg-yellow-50"
                    }, _hoisted_87)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_90))
      ]),
      _hoisted_91,
      (
				_ctx.reportDetail?.assessments &&
				_ctx.reportDetail?.assessments?.length > 0
			)
        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("table", _hoisted_95, [
                  _hoisted_96,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportDetail?.assessments, (assessments, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        onClick: ($event: any) => (
									_ctx.$router.push(
										`/report/lesson/${assessments?.lesson_report?.date}?student_id=${_ctx.studentId}`
									)
								),
                        key: index,
                        class: _normalizeClass([
									index % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								, "text-neutral-700 hover:bg-orange-50 cursor-pointer"])
                      }, [
                        _createElementVNode("td", _hoisted_98, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_99, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatDate2(
												assessments.lesson_report.date
											)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_100, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input",
                              style: _normalizeStyle({
												background: _ctx.$filters.tagResult(
													assessments.result
												)?.background,
												color: _ctx.$filters.tagResult(
													assessments.result
												)?.color,
											})
                            }, _toDisplayString(assessments.result), 5)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_101, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_102, [
                              (
													assessments.lesson_report
														.emotion_scale
												)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: 
													require(`@/assets/images/emoji/${
														_ctx.$filters.emoji(
															assessments
																.lesson_report
																.emotion_scale +
																''
														).emoji
													}`)
												,
                                    alt: "",
                                    height: "30",
                                    width: "30"
                                  }, null, 8, _hoisted_103))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_104, [
                          _createElementVNode("div", null, [
                            (assessments.activities)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessments.activities, (a) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "mb-2",
                                      key: a.id
                                    }, _toDisplayString(a.name), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_106, [
                          (
											_ctx.haveMediaByLessonId(
												assessments?.lesson_report?.id
											)
										)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "pl-5 py-4",
                                onClick: ($event: any) => (
											_ctx.openMediaPopup(
												[
													_ctx.haveMediaByLessonId(
														assessments
															?.lesson_report?.id
													),
												],
												0
											)
										)
                              }, _hoisted_109, 8, _hoisted_107))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_110, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_111, _toDisplayString(assessments.note), 1)
                          ])
                        ])
                      ], 10, _hoisted_97))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}